import createSagaMiddleware from 'redux-saga';
import chartsMiddleware from '../pages/ProjectsPage/middleware/ProjectsPage';
import showChartMiddleware from '../pages/ShowChartPage/middleware/ShowChartPage';
import customiseEditorMiddleware from '../pages/CustomiseEditorPage/middleware/CustomiseEditorPage';
import settingsMiddleware from '../pages/SettingsPage/middleware/SettingsPage';
import apiMiddleware from '../pages/ApiPage/middleware/ApiPage';
import teamWebhooksMiddleware from '../pages/TeamWebhooksPage/middleware/TeamWebhooksPage';
import teamMembersMiddleware from '../pages/TeamMembersPage/middleware/TeamMembersPage';
import teamInvitationsMiddleware from '../pages/TeamInvitationsPage/middleware/TeamInvitationsPage';
import teamGroupsMiddleware from '../pages/TeamGroupsPage/middleware/TeamGroupsPage';
import plansMiddleware from '../pages/PlansPage/middleware/PlansPage';
import billingMiddleware from '../pages/BillingPage/middleware/BillingPage';
import billingHistoryMiddleware from '../pages/BillingHistoryPage/middleware/BillingHistoryPage';
import themesMiddleware from '../pages/ThemesPage/middleware/ThemesPage';
import layoutEditor from '../pages/LayoutEditorPage/middleware/layoutEditor';
import tableEditor from '../pages/TableEditorPage/middleware/tableEditor';
import tableEditorData from '../pages/TableEditorPage/middleware/tableEditorData';
import tableEditorThemes from '../pages/TableEditorPage/middleware/tableEditorThemes';
import tableEditorInlineStyle from '../pages/TableEditorPage/middleware/tableEditorInlineStyle';
import chartEditor from '../pages/ChartEditorPage/middleware/ChartEditor';
import chartEditorData from '../pages/ChartEditorPage/middleware/ChartEditorData';
import DataGrid from '../pages/ChartEditorPage/middleware/DataGrid';
import chartEditorTemplates from '../pages/ChartEditorPage/middleware/ChartEditorTemplates';
import chartEditorThemes from '../pages/ChartEditorPage/middleware/ChartEditorThemes';
import chartEditorCustomize from '../pages/ChartEditorPage/middleware/ChartEditorCustomize';
import ChartEditorMap from '../pages/ChartEditorPage/middleware/ChartEditorMap';
import ChartEditorAnnotations from '../pages/ChartEditorPage/middleware/ChartEditorAnnotations';
import profileMiddleware from './Profile';
import projectEditor from './editor/ProjectEditor';
import themeEditor from './../pages/ThemeEditorPage/middleware/ThemeEditor';
import * as Sentry from '@sentry/react';

const sagaMiddleware = createSagaMiddleware({
  onError: Sentry.captureException
});

export function init() {
  sagaMiddleware.run(profileMiddleware);
  sagaMiddleware.run(chartsMiddleware);
  sagaMiddleware.run(customiseEditorMiddleware);
  sagaMiddleware.run(settingsMiddleware);
  sagaMiddleware.run(apiMiddleware);
  sagaMiddleware.run(teamMembersMiddleware);
  sagaMiddleware.run(teamGroupsMiddleware);
  sagaMiddleware.run(teamWebhooksMiddleware);
  sagaMiddleware.run(teamInvitationsMiddleware);
  sagaMiddleware.run(layoutEditor);
  sagaMiddleware.run(tableEditor);
  sagaMiddleware.run(tableEditorData);
  sagaMiddleware.run(tableEditorThemes);
  sagaMiddleware.run(tableEditorInlineStyle);
  sagaMiddleware.run(themesMiddleware);
  sagaMiddleware.run(plansMiddleware);
  sagaMiddleware.run(billingMiddleware);
  sagaMiddleware.run(billingHistoryMiddleware);
  sagaMiddleware.run(billingHistoryMiddleware);
  sagaMiddleware.run(showChartMiddleware);
  sagaMiddleware.run(chartEditor);
  sagaMiddleware.run(chartEditorData);
  sagaMiddleware.run(chartEditorTemplates);
  sagaMiddleware.run(chartEditorThemes);
  sagaMiddleware.run(chartEditorCustomize);
  sagaMiddleware.run(ChartEditorMap);
  sagaMiddleware.run(themeEditor);
  sagaMiddleware.run(ChartEditorAnnotations);
  sagaMiddleware.run(DataGrid);
  sagaMiddleware.run(projectEditor);
}

export default sagaMiddleware;
